module.exports = __webpack_public_path__ + "static/img/s504.65de442.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s504.png
// module id = 566
// module chunks = 3